// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picture-element[data-v-21d803ea]{display:inline-block}.picture-element .provider-icon[data-v-21d803ea]{border-radius:8px;height:32px;width:80px;aspect-ratio:80/32;min-width:80px;min-height:32px}", ""]);
// Exports
module.exports = exports;
